import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'
import { runSwKillswitch } from './utils/swKillswitch'

// sw-push.js 已透過 VitePWA 的 importScripts 整合進 Workbox Service Worker
// 不需要在此另外註冊，避免與 Workbox SW 在同一 scope 競爭

// 偵測舊 SW 殘留的問題快取並自動清除（必要時會 reload）。
// 不用 await — 命中時內部會 reload，沒命中也不阻擋 React mount。
void runSwKillswitch()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
